"use client";

import { ErrorLayout } from "@/components/layouts/error-layout";

export function MainErrorFallback() {
  return (
    <ErrorLayout message="Please refresh or try again in a few moments." title="Sorry, we couldn't load this page.">
      <p className="ausd-text-body mt-5 text-center">
        If this issue persists, please contact us at{" "}
        <a
          className="underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring"
          href="mailto:help@agora.finance"
        >
          help@agora.finance
        </a>
        .
      </p>
    </ErrorLayout>
  );
}
